// @ts-check

import { cartFetchAndRender } from '@theme/lib-cart';

/** @type {WeakSet<HTMLFormElement>} */
var inFlightForms = new WeakSet();

/**
 * @param {boolean} isBusy
 */
function setSideCartBusyState(isBusy) {
  var sideCart = document.getElementById('side-cart');
  if (!(sideCart instanceof HTMLElement)) return;

  if (isBusy) {
    sideCart.setAttribute('aria-busy', 'true');
  } else {
    sideCart.removeAttribute('aria-busy');
  }
}

/**
 * @param {HTMLFormElement} form
 */
async function submitClearCartForm(form) {
  if (inFlightForms.has(form)) return;

  inFlightForms.add(form);

  var isSideCartForm = !!form.closest('.side-cart');
  if (isSideCartForm) setSideCartBusyState(true);

  var submitButtons = form.querySelectorAll('button[type="submit"]');
  submitButtons.forEach(function (button) {
    if (!(button instanceof HTMLButtonElement)) return;

    button.dataset.wasDisabled = button.disabled ? 'true' : 'false';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
  });

  try {
    await cartFetchAndRender(
      'cart/clear.js',
      {},
      {
        action: 'update',
        context: 'cart',
        lines: [],
      }
    );
  } catch (error) {
    console.error('Clear cart failed:', error);
  } finally {
    submitButtons.forEach(function (button) {
      if (!(button instanceof HTMLButtonElement)) return;

      if (button.dataset.wasDisabled === 'true') {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }

      delete button.dataset.wasDisabled;
    });

    if (isSideCartForm) setSideCartBusyState(false);

    inFlightForms.delete(form);
  }
}

/**
 * Intercepts clear-cart form submissions, sends the request via the Cart Ajax
 * API with Section Rendering, and updates cart UI in-place.
 */
document.addEventListener(
  'click',
  function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('.cart-clear-form button[type="submit"]');
    if (!(button instanceof HTMLButtonElement)) return;

    var form = button.form;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('cart-clear-form')) return;

    event.preventDefault();
    submitClearCartForm(form);
  },
  true
);

document.addEventListener(
  'submit',
  function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('cart-clear-form')) return;

    event.preventDefault();
    submitClearCartForm(form);
  },
  true
);
